import { InjectionToken } from '@angular/core';

export type SelectedApplicationId = () => string | null;

export const SELECTED_APPLICATION_ID = new InjectionToken<SelectedApplicationId>('SELECTED_APPLICATION_ID');
